import { useContext } from 'react';

import {
  type ToggleButtonGroupContextType,
  ToggleButtonGroupContext,
} from '../contexts/ToggleButtonGroupContext.js';

/** @internal */
export const useToggleButtonGroupContext = (): ToggleButtonGroupContextType => {
  return useContext(ToggleButtonGroupContext);
};
